// components/form/TextAreaInput.tsx
import React from 'react'
import { FieldHookConfig, useField } from 'formik'

type TextAreaInputProps = FieldHookConfig<string> & {
  label?: string
  labelPosition?: 'top' | 'left'
  placeholder?: string
  rows?: number
  className?: string
  wrapperClassName?: string
  readOnly?: boolean
}

const TextAreaInput: React.FC<TextAreaInputProps> = ({
  label,
  labelPosition = 'top',
  placeholder = '',
  rows = 4,
  className = '',
  wrapperClassName = '',
  readOnly = false,
  ...props
}) => {
  const [field, meta] = useField(props)
  const isInvalid = meta.touched && meta.error

  const renderLabel = () => {
    if (!label) return null

    return (
      <label className={`form-label fw-bold ${labelPosition === 'left' ? 'mb-0' : ''}`}>
        {label}
      </label>
    )
  }

  const textareaElement = (
    <div className={labelPosition === 'left' && label ? 'flex-grow-1' : 'w-100'}>
      <textarea
        rows={rows}
        placeholder={placeholder}
        className={['form-control', isInvalid && 'is-invalid', className].filter(Boolean).join(' ')}
        readOnly={readOnly}
        {...field}
      />
      {isInvalid && <div className="invalid-feedback">{meta.error}</div>}
    </div>
  )

  if (labelPosition === 'left' && label) {
    return (
      <div className={`${wrapperClassName} h-100`}>
        <div className='d-flex align-items-start gap-3 h-100'>
          <div className='flex-shrink-0 pt-2'>
            {renderLabel()}
          </div>
          {textareaElement}
        </div>
      </div>
    )
  }

  return (
    <div className={`${wrapperClassName} h-100`}>
      {renderLabel()}
      {textareaElement}
    </div>
  )
}

export default TextAreaInput